export const showApiError = (err: any): void => {
    let finalMessage = typeof err === 'string' ? err : (err?.response?.data?.detail || err?.message || 'Error en la petición');
    if (typeof finalMessage === 'string' && finalMessage.toLowerCase().includes('network error')) {
        finalMessage = 'Error en el servidor';
    }
    window.dispatchEvent(new CustomEvent('api-error', { detail: finalMessage }));
};

export const showSuccessToast = (message: string): void => {
    window.dispatchEvent(new CustomEvent('api-success', { detail: message }));
};
